import DomainEntity from '@/models/DomainEntity'

export default class StateStuffs extends DomainEntity {
  static get collectionName() {
    return 'statestuffs/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      items: {},
    }
  }
}
